import { render, staticRenderFns } from "./PasteUpload.vue?vue&type=template&id=6a407b52"
import script from "./PasteUpload.vue?vue&type=script&lang=js"
export * from "./PasteUpload.vue?vue&type=script&lang=js"
import style0 from "./PasteUpload.vue?vue&type=style&index=0&id=6a407b52&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports